import * as _ from 'lodash';
import { fromJS } from 'immutable';

import { fetchingState } from '@constants';
import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';

import * as actions from '../actions/arbitrationProperties';

const initialState = fromJS({
  data: [],
  state: null,
  stateUpdate: null,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_PROPERTIES_START: {
      return state.setIn(['state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PROPERTIES_SUCCESS: {
      return state
        .setIn(['state'], fetchingState.LOADED)
        .setIn(['data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_PROPERTIES_ERROR: {
      return state.setIn(['state'], fetchingState.ERROR);
    }
    case actions.DISTRIBUTE_PRORATA[START]: {
      return state.setIn(['state'], fetchingState.FETCHING);
    }
    case actions.DISTRIBUTE_PRORATA[SUCCESS]: {
      return state
        .setIn(['state'], fetchingState.LOADED)
        .setIn(['data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.DISTRIBUTE_PRORATA[ERROR]: {
      return state.setIn(['state'], fetchingState.ERROR);
    }
    case actions.INSERT_ARBITRATION_PROPERTY[START]: {
      return state.setIn(['state'], fetchingState.FETCHING);
    }
    case actions.INSERT_ARBITRATION_PROPERTY[SUCCESS]: {
      return state.setIn(['state'], fetchingState.LOADED);
    }
    case actions.INSERT_ARBITRATION_PROPERTY[ERROR]: {
      return state.setIn(['state'], fetchingState.ERROR);
    }
    case actions.DELETE_ARBITRATION_PROPERTY[START]: {
      return state.setIn(['state'], fetchingState.FETCHING);
    }
    case actions.DELETE_ARBITRATION_PROPERTY[SUCCESS]: {
      return state.setIn(['state'], fetchingState.LOADED);
    }
    case actions.DELETE_ARBITRATION_PROPERTY[ERROR]: {
      return state.setIn(['state'], fetchingState.ERROR);
    }
    default: {
      return state;
    }
  }
};
